import { TransactionWarningActionEnum } from '../types';

export default function getWarningActionName(name: string) {
  let actionName;

  switch (name) {
    case TransactionWarningActionEnum.PASS_ALL_TIME_FOR_THIS_CLIENT:
      actionName = 'Pass all time for this client';
      break;
    case TransactionWarningActionEnum.PASS_ONCE:
      actionName = 'Pass once';
      break;
    case TransactionWarningActionEnum.PASS_COMBINATION:
      actionName = 'Pass combination';
      break;
    case TransactionWarningActionEnum.RFI_TO_CLIENT_CLARIFICATIONS:
      actionName = 'Rfi to lient clarifications';
      break;
    case TransactionWarningActionEnum.RFI_TO_CLIENT_DOCS:
      actionName = 'Rfi to client docs';
      break;
    case TransactionWarningActionEnum.STOP:
      actionName = 'Stop';
      break;
    default:
      actionName = name;
      break;
  }

  return actionName;
}
